import React, { useState, useEffect } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  FlatList,
} from "react-native";
import * as IMG_CONST from '../../../blocks/dashboard/src/assets'
import { ROLE_ID } from "../../../../packages/framework/src/Utilities";

export default function Footer({
  navigation,
  userData,
}: {
  navigation: any;
  userData: any;
}) {

  const [color, setColor] = useState<any>({
    id1: false,
    id2: false,
    id3: false,
    id4: false,
  });
  const changeRoute = (route: any) => {
    navigation.navigate(route);
  };

  useEffect(() => {
    const assignlist = () => {
      const user = JSON.parse(
        localStorage.getItem("loggedinUserInfo") || "{}"
      );
      let id = Number(user.role_id).toString()
      if (id === ROLE_ID.SURGEON) {
        setrouteList(routeListSurgeon);
      } else if (id === ROLE_ID.MATERIAL_MANAGER) {
        setrouteList(routeListMaterialManage);
      } else if (id === ROLE_ID.BOOKING_COORDINATOR) {
        setrouteList(routeListBookingCoordinator);
      } else {
        setrouteList(routeListSalesRep);
      }
    };

    assignlist();
  }, []);

  const routeListSurgeon = [
    {
      name: "Dashboard",
      routename: "Dashboard",
      status: "confirmed",
      image: IMG_CONST.homeImg
    },
    {
      name: "Start Booking",
      routename: "CreateBooking",
      status: "confirmed",
      image: IMG_CONST.add
    },
    {
      name: "All Bookings",
      routename: "ExBooking",
      status: "confirmed",
      image: IMG_CONST.book
    },

    {
      name: "Catalogue",
      routename: "CatalogueManufacturer",
      status: "confirmed",
      image: IMG_CONST.shopping
    },
  ];

  const routeListMaterialManage = [
    {
      name: "Dashboard",
      routename: "Dashboard",
      status: "confirmed",
      image: IMG_CONST.homeIcon
    },
    {
      name: "My Facility",
      routename: "UserFacilities",
      status: "confirmed",
      image: IMG_CONST.add
    },
    {
      name: "All Bookings",
      routename: "ExBooking",
      status: 'confirmed',
      image: IMG_CONST.book
    },
    {
      name: "Validate",
      routename: "ValidateManager",
      status: 'confirmed',
      image: IMG_CONST.validate
    },
  ];

  const routeListBookingCoordinator = [
    {
      name: "Dashboard",
      routename: "Dashboard",
      status: "confirmed",
      image: IMG_CONST.homeImg
    },
    {
      name: "My Facility",
      routename: "UserFacilities",
      status: "confirmed",
      image: IMG_CONST.hospital
    },
    {
      name: "All Bookings",
      routename: "ExBooking",
      status: 'confirmed',
      image: IMG_CONST.book
    },
    {
      name: "Validate",
      routename: "ValidateBC",
      status: 'confirmed',
      image: IMG_CONST.validate
    },
  ];

  const routeListSalesRep = [
    {
      name: "Dashboard",
      routename: "Dashboard",
      status: "confirmed",
      image: IMG_CONST.homeImg
    },
    {
      name: "My Facility",
      routename: "UserFacilities",
      status: "confirmed",
      image: IMG_CONST.hospital
    },
    {
      name: "All Bookings",
      routename: "ExBooking",
      status: "confirmed",
      image: IMG_CONST.book
    },
    {
      name: "Catalogue",
      routename: "CatalogueManufacturer",
      status: "confirmed",
      image: IMG_CONST.shopping
    },
  ];

  const [routeList, setrouteList] = useState<any>([]);

  return (
    <View style={styles.container}>
      <FlatList
        data={routeList}
        horizontal={true}
        scrollEnabled={true}
        keyExtractor={(item: any) => item.name}
        renderItem={({ item }) => {
          return (
            <View>
              {item.status === "pending" ? (
                <View>
                  <View style={styles.list}>
                    <View style={styles.innerdiv}>
                      <img src={item.image} style={{ height: 20, width: 18 }} />
                      <Text style={styles.text2}>{item.name}</Text>
                    </View>
                  </View>
                </View>
              ) : (
                <TouchableOpacity onPress={() => changeRoute(item.routename)}>
                  <View style={styles.list}>
                    <View style={styles.innerdiv}>
                      <img src={item.image} style={{ height: 20, width: 18 }} />
                      <Text style={styles.text}>{item.name}</Text>
                    </View>
                  </View>
                </TouchableOpacity>
              )}
            </View>
          );
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flex: 1,
    // marginHorizontal: 'auto',
    paddingVertical: 6,
    paddingHorizontal: 22,
    borderColor: "#000000",
    shadowColor: "#000000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  list: {
    width: "100%",
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 9,
    // marginHorizontal: 'auto'
  },
  innerdiv: {
    alignItems: "center",
    flex: 1,
    flexDirection: "column",
  },
  text: {
    color: "#486484",
    justifyContent: "center",
    fontSize: 13,
  },
  text2: {
    color: "#b2bac6",
    justifyContent: "center",
    fontSize: 13,
  },
});
